import { Box, Stack } from "@mui/material";
import { useState } from "react";
import { AccordionTransition } from "../../common/AccordionTransition";
import { FilesFieldCard } from "../../feat/editItinerary/components/filesFieldCard";
import { TextFieldCard } from "../../feat/editItinerary/components/textFieldCard";
import { Expand } from "../../home/components/Expand";
import i18n from "../../i18n/i18next";
import { EditButton } from "./editButton";
import { UsersList } from "./usersList";
interface IHireCarsPassengersBodyProps {
  id?: string;
  data: any;
  renderOptions: IHireCarsPassengersBodyOptions;
}

interface IHireCarsPassengersBodyOptions {
  listFieldId: number;
  icon?: string;
  editPageId?: number;
  userListKey: string;
}
export const HireCarsPassengersBody = ({ id, data, renderOptions }: IHireCarsPassengersBodyProps) => {
  const [chevroClickOpen, setChevroClickOpen] = useState<boolean>(false);

  const userList = () => {
    const hideUserList = data?.[renderOptions.userListKey]?.length === 0;

    return (
      <>
        <Stack direction="row" sx={{
          justifyContent: "space-between"
        }}>
          {hideUserList ? (
            <div />
          ) : (
            <Box
              onClick={() => {
                setChevroClickOpen(!chevroClickOpen);
              }}
              sx={{
                height: "24px"
              }}
            >
              <Expand expanded={chevroClickOpen} />
            </Box>
          )}

          <EditButton id={id} data={data} renderOptions={{ pageId: renderOptions.editPageId }} />
        </Stack>
        {!hideUserList && (
          <AccordionTransition open={chevroClickOpen}>
            <UsersList
              id={id}
              data={data}
              renderOptions={{
                users: renderOptions.userListKey,
                hideChat: true,
              }}
            />
          </AccordionTransition>
        )}
      </>
    );
  };

  return (
    <Stack spacing="16px">
      <TextFieldCard id={id} description={i18n.t("edit-itinerary.fields.423")} text={data.notes} />
      <FilesFieldCard id={id} description={i18n.t("edit-itinerary.fields.documents")} files={data.documents} />
      {userList()}
    </Stack>
  );
};
